import script from "./ImageAndTextSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageAndTextSection.vue?vue&type=script&setup=true&lang=ts"

import "./ImageAndTextSection.vue?vue&type=style&index=0&id=6b930769&lang=scss"

const __exports__ = script;

export default __exports__